import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransactionMenuRoutingModule } from './transaction-menu-routing.module';
import {
  ColumnChooserService,
  FilterService,
  GridModule,
  PageService,
  ResizeService,
  SortService,
} from '@syncfusion/ej2-angular-grids';
import { TransactionMenuComponent } from './transaction-menu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MyDatePickerModule } from 'mydatepicker';
import { TransactionDataMenuService } from './transaction-menu.dataservice';


@NgModule({
  declarations: [TransactionMenuComponent],
  imports: [
    CommonModule,
    MultiselectDropdownModule,
    NgxPaginationModule,
    NgSelectModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    MyDatePickerModule,
   TransactionMenuRoutingModule,
   ReactiveFormsModule,
   FormsModule,
   GridModule

  ],
  providers: [ColumnChooserService,PageService,SortService,FilterService, ResizeService,TransactionDataMenuService],
})
export class TransactionMenuModule { }
